import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import rehypeReact from "rehype-react";
import Collapsable from "../components/collapsable";



const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: { "hidden-block": Collapsable },
}).Compiler


export default function GenericTemplate({data}) {
  const { markdownRemark } = data; // data.markdownRemark holds our post data
  const { frontmatter, parent, htmlAst } = markdownRemark;

  return (
    <Layout currentPage={frontmatter} modified={parent.modifiedTime}>
      <div>
            <h1>{ frontmatter.title }</h1>
            {/* <div dangerouslySetInnerHTML={{ __html: html }} /> */}
            {renderAst(htmlAst)}
        </div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      frontmatter {
        path
        title
        name
      }
      parent {
        ... on File {
          id
          name
          modifiedTime(formatString: "MMM D YYYY HH:mm")
        }
      }
    }
  }`